const PageTitleSection = ({
  title,
  children,
}: {
  title: string
  children?: React.ReactNode
}) => {
  return (
    <div className="mb-6 md:flex md:items-center md:justify-between">
      <header className="text-2xl font-medium print:hidden">{title}</header>
      {children}
    </div>
  )
}

export default PageTitleSection
